import { useState } from "react";

export function useCollapsible(items, initialCount = 4) {
  const [expanded, setExpanded] = useState(false);

  return {
    visibleItems: expanded ? items : items.slice(0, initialCount),
    expanded,
    toggle: () => setExpanded((e) => !e),
    hasMore: items.length > initialCount,
  };
}
